import HCMsettings from '@/config/cosmoMarketing/pages/culture/index'

export default {
  data() {
    return {
      heroConfig: this.$t('pages.culture.Hero'),
      loveInclusionConfig: this.$t('pages.culture.LoveInclusion'),
      pilarsConfig: this.$t('pages.culture.Pilars'),
      hotHeroes: this.$t('pages.culture.HotHeroes'),
      mantrasConfig: this.$t('pages.culture.Mantras'),
      socialsConfig: this.$t('components.Socials'),
    }
  },
}
